import { Clientes } from '@/interface/cliente.model';
import { Producto, Productos, TipoProductos } from '@/interface/producto.model';
import { FechaFunctionsService } from '@/utils/functions.service';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { GeneralService } from '@services/general.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-lista-productos',
  templateUrl: './lista-productos.component.html',
  styleUrls: ['./lista-productos.component.scss']
})
export class ListaProductosComponent {
  @Input() rows: Array<Producto>;
  @Input() tempRows: Array<Producto>;
  @Input() showFilter: boolean = true;
  @Input() showDelete: boolean = true;
  @Output() updateData = new EventEmitter();
  tipoProductos: TipoProductos;
  messages: any

  selected = [];

  @ViewChild('table') table: DatatableComponent;
  isEditable = {};

  constructor(
    public generalService: GeneralService,
    private toastr: ToastrService,
    public Func: FechaFunctionsService,) {
    this.messages = {
      emptyMessage: 'Sin registros para mostrar',
      totalMessage: 'total',
      selectedMessage: 'selected'
    }
  }

  async ngOnInit() {
    await this.getTipoProductos();
  }

  async getTipoProductos() {
    try {
      let res = await this.generalService.getListar("tipo_producto")
      this.tipoProductos = res.data;
    } catch (error) {
      this.tipoProductos = null
    }
  }

  updateFilter(event, type) {
    const val = event.target.value.toLowerCase();


    // filter our data
    const temp = this.tempRows.filter(function (d) {
      switch (type) {
        case 1:
          return d.id_tipoproducto == val || val == '-1';
        case 2:
          return d.nombre.toLowerCase().indexOf(val) !== -1 || !val;
        default:
          return d.nombre.toLowerCase().indexOf(val) !== -1 || !val;
      }
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }


  // Open/close panel  
  toggleExpandRow(row, expanded) {
    this.table.rowDetail.toggleExpandRow(row);
    if (!expanded) {
      this.table.rowDetail.collapseAllRows();
      this.table.rowDetail.toggleExpandRow(row);
    }
    else if (expanded) {
      this.table.rowDetail.collapseAllRows();
    }
  }

  // Save row
  save(row, rowIndex) {
    this.isEditable[rowIndex] = !this.isEditable[rowIndex]
    let payload = {
      valor: row.valor,
      costo: row.costo,
      procesamiento: row.procesamiento
    }
    this.generalService
      .patchEdita("producto", row.id_producto, payload)
      .then(res => {
        this.toastr.success('Producto actualizado correctamente!');
        this.updateData.emit();
      })
      .catch(err => this.toastr.error('Error al actualizar!'));
  }

  // Delete row
  delete(row, rowIndex) {
    this.isEditable[rowIndex] = !this.isEditable[rowIndex]
    this.generalService.patchEdita("producto", row.id_producto, { habilitado: row.habilitado == 0 ? 1 : 0 })
      .then(res => {
        this.toastr.success('Producto eliminado correctamente!');
        this.updateData.emit();
      }).catch(err => this.toastr.error('Error al eliminar!'))

  }
}
